module.exports = __webpack_public_path__ + "img/tv.06dc1221.svg";